/**
 * Generated bundle index. Do not edit.
 */
export { BSModalContext, BSModalContextBuilder, BSModalContainer, BSMessageModal, BSMessageModalTitle, BSMessageModalBody, BSModalFooter, MessageModalPresetBuilder, ModalOpenContext, ModalOpenContextBuilder, OneButtonPresetBuilder, TwoButtonPresetBuilder, PromptPresetBuilder, Modal, bootstrap4Mode, BootstrapModalModule, providers } from './bootstrap';
export { AbstractTwoButtonPresetBuilder as ɵa } from './presets/two-button-preset';
//# sourceMappingURL=angular2-modal-bootstrap.ng-flat.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/angular2-modal/plugins/bootstrap/src/angular2-modal-bootstrap.ng-flat.js
// module id = 20
// module chunks = 0